// extracted by mini-css-extract-plugin
export var header = "_c1-0";